import * as providerManagementActions from '../actions/providerManagement';

const defaultState = {
    serviceProviders: [],
    officerInvites: [],
    officers: [],
    serviceProvider: null,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case providerManagementActions.SERVICE_PROVIDERS_REFRESHED:
            return {
                ...state,
                serviceProviders: action.serviceProviders,
            };
        case providerManagementActions.SERVICE_PROVIDER_REFRESHED:
            return {
                ...state,
                serviceProvider: action.serviceProvider,
            };
        case providerManagementActions.OFFICERS_REFRESHED:
            return {
                ...state,
                officers: action.officers,
            };
        case providerManagementActions.OFFICER_INVITES_REFRESHED:
            return {
                ...state,
                officerInvites: action.officerInvites,
            };
        case providerManagementActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
